import React, {Component} from 'react';
import T from 'i18n-react';
import debounce from 'lodash.debounce';
// Service
import JobHistoryService from '../../services/JobHistoryService'
import OperationService from '../../services/OperationService'
import {makeCancelable} from '../../utils/PromiseUtils';
// Utils
import {notificationStyle} from '../../utils/NotificationUtils';
import {exportOperationCsv} from '../../utils/ExportCsvUtils'
import NotificationSystem from 'react-notification-system';
// Style
import './JobHistoryPage.css'
// Constantes
import JOB_STATUS from '../../enums/JobStatus'
import SORTABLE_JOB_HISTORY_COLUMNS from '../../enums/SortableJobHistoryColumnsEnum';
import SORT from '../../enums/SortEnum';
// Component
import DialogText from '../../components/dialogLongText/DialogText'
import Pagination from '../../components/pagination/Pagination';
import SortComponent from '../../components/sort/SortComponent';
import JobHistoryFilters from "../../components/tableComponent/jobHistory/JobHistoryFilters";
import MenuOperationNotLinked from './MenuOperationNotLinked';

const JOB_BY_PAGE_OPTIONS = [10, 20, 50];

class JobHistoryPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            resourceList: [],
            total: 0,
            filterList: {
                statusList: [],
                fileName: '',
                jobTypeList: [],
                startDate: null,
                endDate: null,
            }
        };
        this.table = {
            totalPage: 0,
            jobByPage: JOB_BY_PAGE_OPTIONS[0],
            page: 1,
            columnToSortList: [SORTABLE_JOB_HISTORY_COLUMNS.DATE],
            sort: SORT.DESC
        };

        this._promises = [];
        this.getMoreHistory();
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.resetFilters = this.resetFilters.bind(this);
        this.getCsv = this.getCsv.bind(this);
        this._addNotification = this._addNotification.bind(this);
        //Méthode avec debounce pour optimiser les appels (sur la recherche fulltext). cf. https://fr.reactjs.org/docs/faq-functions.html#debounce
        this.getMoreHistoryDebounced = debounce(this.getMoreHistory, 300);
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
    }

    componentWillUnmount() {
        this._promises.forEach(promise => promise.cancel());
        this.getMoreHistoryDebounced.cancel();
    }

    render() {
        return (
            <div className='jobHistoryContent'>
                <div className='title'>
                    <div> {T.translate('jobHistory.title')} </div>
                    <div>{this.state.total}&nbsp;{T.translate('jobHistory.file')}</div>
                    <MenuOperationNotLinked handleClick={this.getCsv}/>
                </div>
                <div className="filters">
                    <JobHistoryFilters
                        handleFilterChange = {this.handleFilterChange}
                        resetFilters = {this.resetFilters}
                        {...this.state.filterList}
                    />
                </div>
                <div className="headerTable">
                    <div className='table'>
                        <div className="row">
                            <div className="table-header">
                                <SortComponent isSelected={this.table.columnToSortList[0] === SORTABLE_JOB_HISTORY_COLUMNS.DATE}
                                                action={this.setSortedColumnList.bind(this, [SORTABLE_JOB_HISTORY_COLUMNS.DATE])}
                                                text={T.translate('jobHistory.date')}/>
                            </div>
                            <div className="table-header largerColumn">{T.translate('jobHistory.filename')}</div>
                            <div className="table-header">
                                <SortComponent isSelected={this.table.columnToSortList[0] === SORTABLE_JOB_HISTORY_COLUMNS.FILETYPE}
                                                action={this.setSortedColumnList.bind(this, [SORTABLE_JOB_HISTORY_COLUMNS.FILETYPE])}
                                                text={T.translate('jobHistory.fileType')}/>
                            </div>
                            <div className="table-header">
                                <SortComponent isSelected={this.table.columnToSortList[0] === SORTABLE_JOB_HISTORY_COLUMNS.STATUS}
                                                action={this.setSortedColumnList.bind(this, [SORTABLE_JOB_HISTORY_COLUMNS.STATUS])}
                                                text={T.translate('jobHistory.status')}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className='table'>
                        {this.getFormattedBody()}
                    </div>
                </div>
                <div className="footer">
                    <Pagination total={parseInt(this.state.total, 10)}
                                rowsPerPage={JOB_BY_PAGE_OPTIONS}
                                page={parseInt(this.table.page, 10)}
                                numberOfRows={parseInt(this.table.jobByPage, 10)}
                                updateRows={(state) => {
                                    this.table.page = state.page;
                                    this.table.jobByPage = state.numberOfRows;
                                    this.getMoreHistory();
                                }}/>
                </div>
                {this.state.displayError ?
                    <DialogText
                        title={T.translate('jobHistory.errorList')}
                        errorMessage={this.state.errorMessage}
                        open={true}
                        onClose={this.cleanError.bind(this)}/>
                    : null
                }
                <NotificationSystem ref="notificationSystem" style={notificationStyle}/>
            </div>
        )
    }

    setSortedColumnList(columnToSortList) {
        if(this.table.columnToSortList[0] === columnToSortList[0]) {
            this.table.sort = this.table.sort === SORT.ASC ? SORT.DESC : SORT.ASC;
        } else {
            this.table.sort = SORT.ASC;
            this.table.columnToSortList = columnToSortList;
        }
        this.getMoreHistory();
    }

    getCsv(jobType, country) {
        OperationService.getNotLinkOperationList(jobType).then((response) => {
            if (response.operationList.length > 0) {
                exportOperationCsv(response.operationList, 'operation_non_associee_' + jobType + '.csv', jobType, country)
            } else {
                this._addNotification(T.translate('jobHistory.noOperationUnlink', {'country': T.translate(`country.${country}`)}), 'success');
            }
        })
    }

    cleanError() {
        this.setState({
            displayError: false,
            errorMessage: false
        })
    }

    displayError(error) {
        if (error) {
            error.replace('\\n', '<br />');
            this.setState({
                displayError: true,
                errorMessage: error
            })
        }
    }

    getFormattedBody() {
        let bodyList = [];
        this.state.resourceList.forEach((element) => {
            bodyList.push(
                <div className="row" key={element.filename + element.date}>
                    <div>{element.date}</div>
                    <div className="largerColumn actionButton" onClick={() => {this.downloadJobHistory(element.idJobHistory)}}>
                        {element.filename}
                    </div>
                    <div>{element.filetype ? T.translate(`jobHistory.jobType.${element.filetype.toUpperCase()}`) : ''}</div>
                    <div className={"job-status " + (JOB_STATUS[element.status] ? JOB_STATUS[element.status].color : "orange") + (element.jobError ? ' clickable tooltip' : '')}
                         onClick={() => this.displayError(element.jobError)}
                    >
                        {this.getNbError(element)}{T.translate("jobHistory.jobStatus." + element.status)}
                        {element.jobError ? <span className="hooverText">{T.translate('jobHistory.displayError')}</span> : null}
                    </div>
                </div>
            )
        });
        return bodyList;
    }

    getMoreHistory() {
        const getMoreHistoryPromise = JobHistoryService.getHistory(
            this.table.page - 1,
            this.table.jobByPage,
            this.table.sort,
            this.table.columnToSortList,
            this.state.filterList
        );

        const cancelablePromise = makeCancelable(getMoreHistoryPromise);
        this._promises.forEach(promise => promise.cancel());
        this._promises.push(cancelablePromise);

        cancelablePromise
            .promise
            .then((response) => {
                this.setState({
                    resourceList: response.resourceList,
                    total: response.total,
                })
            })
            .catch((error) => {
                if (!error.isCanceled) {
                    this.setState({
                        error
                    });
                }
            })
            .then(() => this.promiseFulfilled(cancelablePromise));
    }

    getNbError(element) {
        if(element.nbError != null && JOB_STATUS[element.status] && JOB_STATUS[element.status].color === "orange" && element.status !== 2){
            return element.nbError + " ";
        }
        return "";
    }

    downloadJobHistory(id) {
        JobHistoryService.downloadJobHistory(id);
    }

    /**********************************************************
     ************************ Filtre  *************************
     **********************************************************/

    resetFilters(){
        this.setState({ filterList : {} }, this.getMoreHistory);
    }

    handleFilterChange(filterKey, filterValue, debounce) {
        const filterList = this.state.filterList;
        filterList[filterKey] = filterValue;
        this.setState(filterList, debounce ? this.getMoreHistoryDebounced : this.getMoreHistory);;
    }

    /*************************************************
     ****************Notifications ******************
     *************************************************/

    _notificationSystem = null;

    _addNotification(message, level) {
        this._notificationSystem.addNotification({
            message,
            autoDismiss: 60,
            level,
            position: 'tr'
        });
    }

    /**********************************************************
     ***************** Gestion des promises *******************
     **********************************************************/

    /**
     * On retire la promise de la liste des promises en cours
     * Cette fonction doit être appelé après que la promise est rempli
     * @param promise
     */
    promiseFulfilled(promise) {
        const index = this._promises.indexOf(promise);

        if (index !== -1) {
            this._promises.splice(index, 1);
        }
    };
}

export default JobHistoryPage;



// WEBPACK FOOTER //
// ./src/ui/jobHistory/JobHistoryPage.js